var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltersMobileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 28,
    height: 24,
    rx: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.673 12.941a1.173 1.173 0 10-.177-2.34 1.173 1.173 0 00.177 2.34zM14.063 12.943a1.173 1.173 0 100-2.346 1.173 1.173 0 000 2.346zM18.502 12.942a1.173 1.173 0 10.243-2.334 1.173 1.173 0 00-.243 2.334z",
    fill: "#fff"
  })));
}
export default SvgFiltersMobileIcon;